import { Component, Injector, OnInit } from '@angular/core';
import { StkmmService, templateUrlConfigStk } from './../_service_stk';
import { MaterialModule } from 'jk-service';
import { StkmmEditComponent, } from './../_edit_stk';
import { PageKind, UiModeType } from 'jk-service';
import { AdvComModule, jkSingleComponent } from 'jk-advcom';
import { JackBaseComponentModule } from 'jk-service';



@Component({
  selector: 'app-stkpi17-detail',
  standalone: true,
  imports: [
    MaterialModule,
    JackBaseComponentModule,
    AdvComModule,
  ],
  templateUrl: templateUrlConfigStk.stkpi17_detail,
  styleUrls: [],
})
export class Stkpi17DetailComponent extends jkSingleComponent implements OnInit {
  override _programId = 'stkpi17-detail';
  constructor() {
    super();
    this.srv = new StkmmService();
    this.pageKind = PageKind.detail;
    this.uiMode = UiModeType.dialog;  //dialog 'tab';
    this.srv.programId = this.programId + '-detail'; // ### modi,不要亂改
    this.srv.linkMasterFields = 'MM001=MJ001,MM002=MJ002';
    this.masterEditPage = StkmmEditComponent;
    this.gridInitOpt = { programId: this.programId, sortField: 'MM004', sort: 'desc', defaultSort: null, pageKind: PageKind.bill };

    this.constructorInit(); // ###

  }



}
